import { useQuery } from '@tanstack/react-query';
import { getAudit } from '../lib/api.js';
import { Card, PageHeader, Pill, Skeleton } from '../components/ui.js';

const ACTION_TONE: Record<string, string> = { create: 'green', update: 'teal', archive: 'amber', unarchive: 'teal', delete: 'red', vote: 'purple', ic_decision: 'gold', import: 'amber' };
const ENTITY_LABEL: Record<string, string> = { deal: 'Deal', team: 'Team', settings: 'Settings', ic_vote: 'IC vote', workspace: 'Workspace' };

export function Activity() {
  const { data, isLoading, error } = useQuery({ queryKey: ['audit'], queryFn: () => getAudit(200), retry: 1 });
  const rows = data?.audit ?? [];

  return (
    <div className="max-w-[900px]">
      <PageHeader eyebrow="Tools" title="Activity log" desc="Append-only audit trail — who changed what, when. Admins only." />
      {error ? (
        <Card><p className="text-[12.5px] text-muted">{String((error as Error).message)}</p></Card>
      ) : (
        <Card bodyClass="p-0">
          <div className="overflow-x-auto">
          <table className="w-full border-collapse text-[12.5px] min-w-[560px]">
            <thead><tr>{['When', 'Who', 'Action', 'Entity', 'Detail'].map((h) => <th key={h} className="text-left text-muted font-bold text-[10.5px] uppercase px-4 py-2.5 border-b border-line-2">{h}</th>)}</tr></thead>
            <tbody>
              {isLoading && Array.from({ length: 6 }).map((_, r) => (
                <tr key={`sk-${r}`} aria-hidden="true">{Array.from({ length: 5 }).map((_, c) => (
                  <td key={c} className="px-4 py-2.5 border-b border-line-2"><Skeleton w={c === 4 ? '80%' : c === 0 ? 120 : 70} h={11} /></td>
                ))}</tr>
              ))}
              {!isLoading && rows.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center text-muted">No activity recorded yet.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} className="hover:bg-canvas align-top">
                  <td className="px-4 py-2 border-b border-line-2 text-muted-2 whitespace-nowrap">{new Date(r.ts).toLocaleString()}</td>
                  <td className="px-4 py-2 border-b border-line-2 font-semibold text-navy">{r.actor ?? '—'}</td>
                  <td className="px-4 py-2 border-b border-line-2"><Pill tone={ACTION_TONE[r.action] ?? 'gray'}>{r.action.replace(/_/g, ' ')}</Pill></td>
                  <td className="px-4 py-2 border-b border-line-2 text-navy">{ENTITY_LABEL[r.entity] ?? r.entity}{r.entityId ? <span className="text-muted-2"> · {r.entityId}</span> : ''}</td>
                  <td className="px-4 py-2 border-b border-line-2 text-muted mono text-[11px]"><div className="max-w-[260px] truncate" title={r.diff && Object.keys(r.diff).length ? JSON.stringify(r.diff) : ''}>{r.diff && Object.keys(r.diff).length ? JSON.stringify(r.diff) : '—'}</div></td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </Card>
      )}
    </div>
  );
}
